import { createEntityAdapter } from '@reduxjs/toolkit'
import { IPrice } from '../../types'

export const pricesAdapter = createEntityAdapter<IPrice>()